import { render, staticRenderFns } from "./DealsHeader.vue?vue&type=template&id=15fad651"
import script from "./DealsHeader.vue?vue&type=script&lang=js"
export * from "./DealsHeader.vue?vue&type=script&lang=js"
import style0 from "./DealsHeader.vue?vue&type=style&index=0&id=15fad651&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports